import type { Anime } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: Anime }) {
  return (
    <article className="group overflow-hidden rounded-2xl bg-background-100 border border-background-200/70 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={anime.image}
          alt={`${anime.title}剧照`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500/95 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-xs"></i>
          {anime.rating}
        </span>
        <span className="absolute right-3 top-3 whitespace-nowrap rounded-full bg-foreground-950/60 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
          {anime.tag}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
          {anime.title}
        </h3>
        <p className="mt-0.5 text-xs md:text-sm text-primary-700 font-medium">{anime.protagonist}</p>
        <p className="mt-2 line-clamp-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
          {anime.desc}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-play-circle-line"></i>
            {anime.episodes}
          </span>
          <span className="whitespace-nowrap">{anime.year}年</span>
        </div>
      </div>
    </article>
  );
}